import React from 'react';
import { string, number, bool, shape, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import useStyles from 'hooks/useStyles';

import Button from 'components/Button';
import LineProgressBar from 'components/LineProgressBar';

import { getLineProgressBarText, getButtonText } from './utils';
import styles from './ContinueLearningCTA.scss';

function ContinueLearningCTA({
  isPreOrdered,
  enrollStartAt,
  courseLearningProgress,
  lessonInfo: { title, learningProgress, duration, remainingDurationMinute },
  onClick,
}) {
  useStyles(styles);
  const { t } = useTranslation(['course']);

  if (isPreOrdered) {
    return (
      <div className={styles.root}>
        <h5>{title}</h5>
        <p className={styles.preOrderedDescription}>
          {t('videoplayer.release.date', { date: enrollStartAt })}
        </p>
        <Button className={styles.button} disabled>
          {t('videoplayer.watch.start')}
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <h5>{title}</h5>
      <LineProgressBar
        classNameMap={{
          root: styles.lineProgressBar,
          progressBody:
            courseLearningProgress === 1
              ? styles.completedProgressBody
              : undefined,
        }}
        progress={learningProgress}
        textStart={getLineProgressBarText({
          courseLearningProgress,
          t,
          duration,
          remainingDurationMinute,
        })}
      />
      <Button className={styles.button} onClick={onClick}>
        {t(`videoplayer.watch.${getButtonText(courseLearningProgress)}`)}
      </Button>
    </div>
  );
}

ContinueLearningCTA.propTypes = {
  isPreOrdered: bool.isRequired,
  enrollStartAt: string.isRequired,
  courseLearningProgress: number.isRequired,
  lessonInfo: shape({
    title: string.isRequired,
    learningProgress: number.isRequired,
    remainingDurationMinute: number.isRequired,
  }).isRequired,
  onClick: func.isRequired,
};

export default ContinueLearningCTA;
